import React from 'react';

import Grid from '@mui/material/Grid2';

import {
  Character,
  CharacterFeature,
  BonusSpells,
  CharacterBonusSpells,
  CharacterSheetInterface,
} from "@dndModels";

import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import CharacterBonusSpellInput from "@dndComponents/character/features/CharacterBonusSpellInput";

interface Props {
  char: CharacterSheetInterface;
  char_feature: CharacterFeature;
  onChange: (changed: CharacterBonusSpells) => void;
}

export default function CharacterBonusSpellsInput({ 
  char,
  char_feature,
  onChange
}: Props) {
  // const [ping, setPing] = useState(false);

  const sfl = char_feature.floating_feature;

  if (sfl instanceof BonusSpells) {
    const char_bs = char_feature.feature_options[0] as CharacterBonusSpells;
    console.log(char_bs);
    const bonus_spell_ids = sfl.spells.map(o => o.spell_id);
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          { sfl.name }
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <DisplayStringWithReplacements display_string={ sfl.description } cfs={char} />
        </Grid>
        { bonus_spell_ids.map(given_id => {
          // console.log(given_id);
          return (
            <CharacterBonusSpellInput key={given_id}
              char_feature={char_feature}
              given_id={given_id}
              onChange={onChange}
            />
          );
        })}
      </Grid>
    );
  }
  return <></>;
}
